import Axios from "./axios";

const endpoint = "/api/orderinvoice";

export default {
  //발주입고 상세
  //{"invoiceId": 0,"orderId": 0,"rebarId": 0,"rebarQuantity": 0}
  orderinvoiceDetail: (data) => Axios.post(`${endpoint}/detail`, data),

  //발주입고목록 조건별 조회
  //{"invoiceId": 0,"orderId": 0,"rebarId": 0,"rebarQuantity": 0}
  orderinvoiceFilterList: (data) => Axios.post(`${endpoint}/create`, data),

  /**
   *
   * @param {Number} constructionId 현장번호
   * @param {Number} type 타입 ex) 1 : 차수, 2: 부위, 3: 동, 4: 층,5: 부재
   * @param {Text} keyword 검색 조건
   * @param {Text} startDate 시작 날짜 'YYYY-MM-DD'
   * @param {Text} endDate 종료 날짜 'YYYY-MM-DD'
   * @param {Number} currentPage 현재 페이지
   * @param {Array} order 정렬 순서 ['desc', 'asc']
   *      [null,null] 기본정렬 / ['desc',null] 첫번쨰 데이터로 정렬 / [null, 'desc'] 두번째 데이터로 정렬 / ['desc', 'desc'] 첫번째 데이터로 정렬
   * @param {Number} pageCount 페이지 출력 갯수
   * @param {Text} dateType
   * -------------
   * @param {Array} filterDongList
   * @param {Array} filterFloorList
   * @param {Array} filterTypeList
   * @param {Array} filterYearList
   * @param {Array} filterStatusList
   * @param {Array} filterMonthList
   * @returns
   */
  orderinvoiceTotalList: (data) => Axios.post(`${endpoint}/total-list`, data),

  orderinvoiceMemo: (data) => Axios.post(`${endpoint}/read-memo`, data),

  orderinvoiceChangeMemo: (data) => Axios.post(`${endpoint}/change-memo`, data),

  /**
   * 실적조회
   * @param {Number} constructionId 현장번호
   * @returns
   */
  achievementList: (data) =>
    Axios.post(`${endpoint}/achievement-total-list`, data),

  /**
   * 필터 리스트 조회
   * @param {Number} constructionId 현장번호
   * @returns
   */
  filterListSearch: (data) => Axios.post(`${endpoint}/search-list`, data),

  /**
   *
   * @param {Number} constructionId 현장번호 not Null
   * @param {Text} type 타입형태
   * @param {Date} selectDate 선택일 YYYY-MM-DD
   * @param {Date} startDate 시작일 YYYY-MM-DD
   * @param {Date} endDate 종료 YYYY-MM-DD
   * @returns
   */
  statisticsList: (data) => Axios.post(`${endpoint}/statistics-list`, data),

  getMonthList: async (payload) => {
    const { data } = await Axios.post(`${endpoint}/month-list`, payload);

    return data;
  },
};
